__turbopack_context__.v({
  "active": "r8H79W_active",
  "content": "r8H79W_content",
  "foodItemCard": "r8H79W_foodItemCard",
  "foodItems": "r8H79W_foodItems",
  "foodZones": "r8H79W_foodZones",
  "mobileFoodZones": "r8H79W_mobileFoodZones",
  "parentContainer": "r8H79W_parentContainer",
  "root": "r8H79W_root",
  "tab": "r8H79W_tab",
  "tabs": "r8H79W_tabs",
  "tag": "r8H79W_tag",
  "zone": "r8H79W_zone",
});
